import { render, staticRenderFns } from "./AuthorisePart.vue?vue&type=template&id=5a4e3bd2&scoped=true"
import script from "./AuthorisePart.vue?vue&type=script&lang=js"
export * from "./AuthorisePart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4e3bd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a4e3bd2')) {
      api.createRecord('5a4e3bd2', component.options)
    } else {
      api.reload('5a4e3bd2', component.options)
    }
    module.hot.accept("./AuthorisePart.vue?vue&type=template&id=5a4e3bd2&scoped=true", function () {
      api.rerender('5a4e3bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AuthorisePart.vue"
export default component.exports